import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { IWCCStorageManager } from 'managers/iStorage';
import { EffectsContainer } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';
import TextThreadEditorVM, { TextThreadEditorVMConfig } from '../textThread';
import './reply.scss';

@injectable()
export default class ReplyEditorVM extends TextThreadEditorVM {
    mediaSize = 75

    constructor(
        @inject(wccModules.componentConfig) config: TextThreadEditorVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(config, info, storage, ctx, effects);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'reply-editor': true
            }
        }, this);
    }    
}